import { redirect } from "@tanstack/react-router";

import { ELocalStorageKeys } from "@/app/types/localStorage";
import { getItemSessionStorage } from "@/lib/utils";

export const validateActiveUser = () => {
  const status = getItemSessionStorage(ELocalStorageKeys.ACCOUNT_STATUS);
  if (status !== "active") {
    throw redirect({ to: "/error/disabled" });
  }
};
